<template>
  <TemplateLogin
    class="login"
    :success="flashMessage.message"
    hide-back-button
    @submit="submitHandle"
  >
    <CalicoBanner
      v-if="errorMessage"
      variant="error"
      fixed
    >
      <span class="body--medium">{{ errorMessage }}</span>
    </CalicoBanner>
    <CalicoForm
      v-slot="{ field, error }"
      name="Email"
      label="Email"
      rules="required|email"
    >
      <CalicoField
        v-model="email"
        v-bind="field"
        maxlength="100"
        :error="error"
      />
    </CalicoForm>
    <CalicoForm
      v-slot="{ field, error }"
      name="Password"
      label="Password"
      rules="required"
    >
      <div class="password-wrapper">
        <CalicoField
          v-model="password"
          v-bind="field"
          :type="showPassword ? 'text' : 'password'"
          :error="error"
          icon="eye"
          @click="showPasswordToggle"
        />
        <span
          class="body--medium"
          style="width: fit-content;"
        >
          <button
            type="button"
            class="button-link" 
            @click="$router.push('/forgot-password')"
          >
            Forgot Password
          </button>
        </span>
      </div>
    </CalicoForm>
    <button
      class="button-secondary"
      type="submit"
      :disabled="loading || !appCheckReady"
    >
      Login
    </button>
    <span class="body--small">or</span>
    <button
      class="button-primary"
      type="button"
      :disabled="loading"
      @click="$router.push('/signup')"
    >
      Sign Up
    </button>
  </TemplateLogin>
</template>

<script lang="js">
import CalicoField from '@/components/calico/field/index.vue'
import TemplateLogin from '@/components/template/login/index.vue'
import CalicoBanner from '@/components/calico/banner/index.vue'
import CalicoForm from '@/components/pattern/form/index.vue'
import { signInWithEmailAndPassword } from 'firebase/auth'
import { flashMessage } from '@/utils/flashMessage'
import { getToken } from "firebase/app-check";
import { appCheck } from "@/main";

export default {
  name: 'LoginComponent',
  components: {
    CalicoField,
    CalicoForm,
    CalicoBanner,
    TemplateLogin
  },
  data() {
    return {
      email: "",
      password: "",
      errorMessage: "",
      loading: false,
      showPassword: false,
      flashMessage,
      appCheckReady: false,
    }
  },
  mounted() {
    getToken(appCheck, false)
      .then(t => { this.appCheckReady = !!(t && t.token); })
      .catch(() => { this.appCheckReady = false; });
  },
  methods: {
    async submitHandle(validate) {
      if (this.loading) return;

      this.errorMessage = "";

      const result = await validate();
      if (!result.valid) {
        return;
      }

      this.loading = true;

      try {
        await signInWithEmailAndPassword(this.$auth, this.email, this.password);

        await this.$router.push("/verify-email");
      } catch (error) {
        switch (error.code) {
          case "auth/invalid-email":
            this.errorMessage = "Incorrect email. Please try again.";
            break;
          case "auth/invalid-credential":
            this.errorMessage = "Incorrect login. Please try again.";
            break;
          case "auth/too-many-requests":
            this.errorMessage = "Too many failed attempts. Please try again.";
            break;
          default:
            this.errorMessage = "An unknown error occurred";
            break;
        }
      } finally {
        this.loading = false;
      }
    },

    showPasswordToggle(e) {
      if(e.target.tagName.toLowerCase() === 'i') {
        this.showPassword = !this.showPassword
      }
    }
  }
}
</script>

<style lang="scss">
.login {
  .password-wrapper {
    @include stack-space($space-xsmall);
    width: 100%;
  }
}
</style>
